import React from 'react';
import { Navigate, Outlet } from 'react-router';

import { DevOnlyRoute } from '@/backoffice/app/dev-only-route/dev-only-route';
import { TCustomRouteObject } from '@/shared/types/router.types';

// DevOnlyRoute gates on its `children` prop, so nested routes need an
// Outlet inside it rather than passing it as the route Component directly.
const Ec2OrchestratorConfigGuard: React.FC = () => (
  <DevOnlyRoute>
    <Outlet />
  </DevOnlyRoute>
);

// Gated by the `custom:isDeveloper` Cognito attribute via DevOnlyRoute on top
// of the RBAC `permission`; the back-office API enforces both as well.
export const ec2OrchestratorConfigRoutes: TCustomRouteObject = {
  path: '/ec2-orchestrator-config',
  Component: Ec2OrchestratorConfigGuard,
  handle: {
    crumb: {
      label: 'ec2_orchestrator_config',
      localized: true,
    },
    permission: { action: 'backofficeEc2OrchestratorConfig:readConfig' },
  },
  children: [
    {
      index: true,
      element: <Navigate to="global" replace />,
    },
    {
      lazy: async () => {
        const { Ec2OrchestratorConfigRoute } =
          await import('./ec2-orchestrator-config');
        return { Component: Ec2OrchestratorConfigRoute };
      },
      children: [
        {
          path: 'global',
          lazy: async () => {
            const { GlobalConfigTabRoute } =
              await import('./ec2-orchestrator-config');
            return { Component: GlobalConfigTabRoute };
          },
        },
        {
          path: 'ide-configs',
          lazy: async () => {
            const { IdeConfigsTabRoute } =
              await import('./ec2-orchestrator-config');
            return { Component: IdeConfigsTabRoute };
          },
        },
        {
          path: 'overrides',
          lazy: async () => {
            const { IdeOverridesTabRoute } =
              await import('./ec2-orchestrator-config');
            return { Component: IdeOverridesTabRoute };
          },
        },
        {
          path: 'history',
          lazy: async () => {
            const { ChangeHistoryTabRoute } =
              await import('./ec2-orchestrator-config');
            return { Component: ChangeHistoryTabRoute };
          },
        },
        {
          path: 'fleet-capacity',
          lazy: async () => {
            const { FleetCapacityTabRoute } =
              await import('./ec2-orchestrator-config');
            return { Component: FleetCapacityTabRoute };
          },
        },
        {
          path: 'run-status',
          lazy: async () => {
            const { RunStatusTabRoute } =
              await import('./ec2-orchestrator-config');
            return { Component: RunStatusTabRoute };
          },
        },
      ],
    },
  ],
};
